// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BH16XrYRjYMP4JZLbS_2{padding-top:40px}.APoptPyxglcwNMzeA1gO{border:1px solid var(--border-neutral-default);border-radius:6px}.ZzQ7X0Js3ag88chMdZuM{align-items:center;gap:5px;height:40px;padding:0 0 0 11px;display:flex}.Q4Ia0kOyb88WvLvSUima{width:100%}.V46GTc_pBm8v6ii5E257{flex-direction:column;gap:8px;display:flex}.y9LDrnuElso2miOiD46m{background-color:var(--background-neutral-subtle);border-radius:6px;align-items:center;gap:16px;height:80px;padding:0 16px;display:flex}.Jz_Jv0j0Hac8kYWaNT5Y{background:var(--black-10);width:40px;height:40px;color:var(--content-primary-tertiary);border-radius:50%;flex:0 0 40px;justify-content:center;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `BH16XrYRjYMP4JZLbS_2`,
	"fields": `APoptPyxglcwNMzeA1gO`,
	"field": `ZzQ7X0Js3ag88chMdZuM`,
	"field__input": `Q4Ia0kOyb88WvLvSUima`,
	"fieldInput": `Q4Ia0kOyb88WvLvSUima`,
	"info": `V46GTc_pBm8v6ii5E257`,
	"infoCard": `y9LDrnuElso2miOiD46m`,
	"infoCard__icon": `Jz_Jv0j0Hac8kYWaNT5Y`,
	"infoCardIcon": `Jz_Jv0j0Hac8kYWaNT5Y`
};
export default ___CSS_LOADER_EXPORT___;
